require('../proposals/array-is-template-object');
require('../proposals/promise-any');
require('../proposals/set-methods');
require('../proposals/string-replace-all');
require('../proposals/using-statement');

module.exports = require('./3');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/stage/2.js
// module id = jCBf
// module chunks = 0